import * as React from 'react';
import type { TContactParam } from '@cian/newbuilding-chat-component';
import { useDispatch, useSelector } from 'react-redux';

import { requestAuthentication } from '../actions/authentication';
import { getGaLabel } from '../selectors/analytics';
import { getUser } from '../selectors/user';
import { closeBuilderChat, openBuilderChat } from '../slices/builderChat';
import { TDispatch } from '../types/redux';
import { trackOpenChat, trackSendMessageClick } from '../utils/analytics';

export function useBuilderChat(placeType: string, sellerType?: 'builders' | 'agents') {
  const dispatch: TDispatch = useDispatch();
  const user = useSelector(getUser);
  const gaLabel = useSelector(getGaLabel);

  const openChatWithTracking = React.useCallback(
    (chatContact: TContactParam) => {
      trackOpenChat({ label: gaLabel, placeType, sellerType });
      dispatch(openBuilderChat(chatContact));
    },
    [dispatch, gaLabel, placeType, sellerType],
  );

  const openChat = React.useCallback(
    (chatContact: TContactParam) => {
      trackSendMessageClick({ label: gaLabel, placeType, sellerType });

      if (!user.isAuthenticated) {
        dispatch(
          requestAuthentication({
            onSuccess: () => () => openChatWithTracking(chatContact),
            onCloseNoAuth: closeBuilderChat,
          }),
        );

        return;
      }

      openChatWithTracking(chatContact);
    },
    [dispatch, openChatWithTracking, gaLabel, placeType, user, sellerType],
  );

  return { openChat };
}
